import { GqlRequestOptions } from '@common/api-request';
import { isExternalReviewVersion } from '@common/app-manager';

import { PdpProductEntryType } from '../graphql/pdp-base-info_types.2';
import { usePdpBaseInfo } from './usePdpBaseInfo';
import { useGetHasExternalReview, useGetPdpIntegratedData } from './usePdpIntegratedData';

export const useProductReviewTotalCount = (productId: string, options?: GqlRequestOptions) => {
  const { product } = usePdpBaseInfo({ catalog_product_id: productId });
  const { related_product_review_summary } = useGetPdpIntegratedData({
    catalog_product_id: productId,
    ...options,
  });
  const { is_exposed } = useGetHasExternalReview(productId);

  const isAvailableExternalReview = product.entry_type !== PdpProductEntryType.DIRECT;

  const isShowExternalReviewCount =
    isExternalReviewVersion() &&
    isAvailableExternalReview &&
    is_exposed &&
    related_product_review_summary?.overview.aggregate.total.count;

  return {
    review_total_count:
      (isShowExternalReviewCount
        ? related_product_review_summary?.overview.aggregate.total.count
        : related_product_review_summary?.overview.aggregate.internal.count) ?? 0,
  };
};
